export default __webpack_public_path__ + "static/media/Resume.2fb7f86a.jpg";